export default __webpack_public_path__ + "static/media/calendar_example.ccb21aa6.png";